import { searchString } from '@/services/router/search-scalars';

/**
 * The finished import's search params.
 *
 * One, set by the wizard's last step so the reader who just finished an import is told it started.
 * Someone opening the page later is not.
 */
export type DetailSearch = {
  new_import?: string;
};

/**
 * `validateSearch` replaces this route's search, so the incoming params are spread to preserve
 * the global ones the page does not own (`masq_account_id`, …) and only this one is narrowed.
 */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
export function validateDetailSearch(search: Record<string, unknown>): Record<string, unknown> & DetailSearch {
  return { ...search, new_import: searchString(search.new_import) };
}
